<div fxLayout="row wrap" fxLayoutAlign="space-around">
  <ng-template ngFor let-content [ngForOf]="linkContents">
    <link-card [content]="content"></link-card>
  </ng-template>
</div>